import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=fdf0e902&"
import script from "./Receiving.vue?vue&type=script&lang=js&"
export * from "./Receiving.vue?vue&type=script&lang=js&"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=fdf0e902&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf0e902')) {
      api.createRecord('fdf0e902', component.options)
    } else {
      api.reload('fdf0e902', component.options)
    }
    module.hot.accept("./Receiving.vue?vue&type=template&id=fdf0e902&", function () {
      api.rerender('fdf0e902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/Receiving.vue"
export default component.exports